import {createReducer} from '@reduxjs/toolkit'
import {GET_EVENT_OLD, GET_MEMBERS_OLD, changeEventAction, getEvent, getMembers} from '../actions/event'
import {EventState} from '../types/state'

const defaultState: EventState = {
  event: null,
}

export const event = createReducer(defaultState, builder => {
  builder
    .addCase(changeEventAction, (state, action) => {
      state.event = action.payload.event
    })
    .addCase(GET_EVENT_OLD.SUCCESS, (state, action) => {
      // @ts-expect-error
      state.event = action.payload
    })
    .addCase(getEvent.fulfilled, (state, action) => {
      state.event = action.payload
    })
    .addCase(GET_MEMBERS_OLD.SUCCESS, (state, action) => {
      // @ts-expect-error
      state.event.members = action.payload.members
      // @ts-expect-error
      state.event.totalGuests = action.payload.totalGuests
    })
    .addCase(getMembers.fulfilled, (state, action) => {
      if (action.payload) {
        state.event.members = action.payload.members
        state.event.totalGuests = action.payload.totalGuests
      }
    })
})
